import { render, staticRenderFns } from "./CustomLanguageSelectWithCopy.vue?vue&type=template&id=049e6a05"
import script from "./CustomLanguageSelectWithCopy.vue?vue&type=script&lang=ts"
export * from "./CustomLanguageSelectWithCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049e6a05')) {
      api.createRecord('049e6a05', component.options)
    } else {
      api.reload('049e6a05', component.options)
    }
    module.hot.accept("./CustomLanguageSelectWithCopy.vue?vue&type=template&id=049e6a05", function () {
      api.rerender('049e6a05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/CustomLanguageSelectWithCopy.vue"
export default component.exports